export default "__VITE_ASSET__BK6PDTdU__"